import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import { get } from 'lodash'
import { apiAccessVerification } from 'helpers/decorators/api'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

export const AccessVerificationContext = React.createContext({
  verifyLoading: false,
  authorized: false,
  validUntil: null,
  verify: () => {},
  sendVerificationCodeToEmail: () => {}
})
const enhance = compose(
  apiAccessVerification(),
  connect(state => ({
    accessVerification: state.api.accessVerification
  }), { push })
)

class AccessVerificationProvider extends PureComponent {
  static propTypes = {
    verifyAccess: PropTypes.func.isRequired,
    sendVerificationCodeToEmail: PropTypes.func.isRequired,
    accessVerification: PropTypes.object,
    children: PropTypes.node
  }

  constructor(props) {
    super(props)
    const query = queryString.parse(get(props, 'location.search'))

    this.authorizationCode = get(query, 'authorizationCode')
  }

  verify = async verificationCode => {
    if (!this.authorizationCode) {
      return
    }
    this.props.verifyAccess(this.authorizationCode, verificationCode)
  }

  sendVerificationCodeToEmail = () => {
    if (!this.authorizationCode) {
      return
    }
    this.props.sendVerificationCodeToEmail(this.authorizationCode)
  }

  render() {
    const { children, accessVerification } = this.props

    const verifyAccess = get(accessVerification, 'verifyAccess', {})
    const sendVerificationCode = get(accessVerification, 'sendVerificationCode', {})

    return (
      <AccessVerificationContext.Provider
        value={{
          verifyLoading: verifyAccess.loading,
          authorized: verifyAccess.authorized,
          validUntil: get(sendVerificationCode.data, 'validUntil', null),
          verify: this.verify,
          sendVerificationCodeToEmail: this.sendVerificationCodeToEmail
        }}
      >
        {children}
      </AccessVerificationContext.Provider>
    )
  }
}

export default enhance(AccessVerificationProvider)
